import Axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Row } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import { goRiceUrl } from '../../../constant/siteConstants';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import getConfigToken from '../../../utils/getConfigToken';
import useFormatMessage from '../../../utils/useFormatMessage';
import PermissionModal from '../components/KullaniciRolYonetimi/PermissionModal';
import UserTable from '../components/KullaniciRolYonetimi/UserTable';

export default function KullaniciRolYonetimi() {
    const notifyError = (message) => toast.error(`${message}`);
    const [modalPermission, setModalPermission] = useState(false);
    const [userDatas, setUserDatas] = useState([]);
    const [updateTrigger, setUpdateTrigger] = useState(true);
    const { t } = useFormatMessage();
    async function getUserDatas() {
        await Axios.post(`${goRiceUrl}/api/employee/getAllEmpoyeesAndRoles`, {}, getConfigToken).then((resp) => {
            if (resp.status === 200) {
                setUserDatas(resp.data);
            } else {
                notifyError("Kullanıcı bilgileri yüklenirken bir hata meydana geldi.");
            }
        }).catch((err) => {
            console.error(err);
            notifyError("Kullanıcı bilgileri yüklenirken bir servis hatası meydana geldi.");
        })
    }
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        getUserDatas();
    }, [updateTrigger])
    /* eslint-disable react-hooks/exhaustive-deps */

    const dataGridRef = useRef();

    return (
        <>
            <Breadcrumb current={t("Kullanıcı Rol Yönetimi")} />
            <div className='card p-4 mb-4'>
                <Row className='mb-3'>
                    <Col xl="12" className='d-flex justify-content-end' style={{ gap: "5px" }}>
                        <Button onClick={() => setModalPermission(true)}>{t("Toplu Kullanıcı Yetki Grubu Atama")}</Button>
                        <Button className='btn-success' style={{ padding: "6px 10px", cursor: "pointer" }} onClick={(e) => { ButtonOnExporting(e, dataGridRef, `Kullanıcı Rol Yönetimi ${moment(new Date()).format("DD/MM/YYYY")}`, "Revizyon 1") }}>
                            <i className='fa fa-file-excel-o' style={{ color: "white" }}></i>
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xl="12">
                        <UserTable dataGridRef={dataGridRef} dataSource={userDatas} updateTrigger={updateTrigger} setUpdateTrigger={setUpdateTrigger} />
                        <PermissionModal modalPermission={modalPermission} setModalPermission={setModalPermission} />
                    </Col>
                </Row>
            </div>
        </>
    )
}